<template>
  <v-flex lg4 md6 sm9>
    <div class="single-pricing mt-4 ma-2" :class="conditionalClass">
      <div class="pricing-header text-center">
        <h5 class="text-black-50" :class="{ 'mb-4': item.paketsms <= 0 }">{{ item.paketadi }}</h5>
        <p class="price" v-if="item.paketsms > 0">{{ item.paketsms.toLocaleString() }} SMS</p>
        <span class="year" v-if="item.paketsms < 50000 && item.id < 58 && item.id !==38 && item.id !==39 && item.id !==40 && item.id !== 44">{{ item.fiyat }} TL</span>
      </div>
      <div class="pricing-list">
        <ul>
          <li>
            <img v-if="item.resim" :src="item.resim" alt="baloon"><br>
            {{ item.aciklama }}
          </li>
          <li v-for="(item, i) in item.ozellikler && JSON.parse(item.ozellikler)"
              :key="`${item.id}-${i}`">
            {{ item }}
          </li>
        </ul>
      </div>
      <div class="pricing-btn text-center">
        <slot name="pricing-btn"></slot>
      </div>
    </div>
  </v-flex>
</template>

<script>
export default {
  name: 'PricingCard',
  props: ['item', 'conditionalClass'],
};
</script>

<style scoped>
  .single-pricing {
    -webkit-box-shadow: 0 3px 6px 0 rgba(0, 0, 0, .16);
    -moz-box-shadow: 0 3px 6px 0 rgba(0, 0, 0, .16);
    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, .16);
    padding: 24px 20px 32px;
    border-radius: 8px;
    position: relative;
    overflow: hidden;
    background-color: #fff;
    transition: all ease-in-out 0.25s;
  }

  .single-pricing:hover {
    transform: scale(1.05);
    transition: all ease-in-out 0.25s;
  }

  .single-pricing .pricing-header .sub-title {
    font-size: 20px;
    font-weight: 600;
    line-height: 25px;
    color: #121212;
    position: relative;
    padding-bottom: 8px
  }


  .single-pricing .pricing-header .price {
    display: block;
    font-size: 32px;
    letter-spacing: -1px;
    font-weight: 600;
    line-height: 40px;
    color: #121212;
  }

  @media only screen and (min-width: 992px) and (max-width: 1200px) {
    .single-pricing .pricing-header .price {
      font-size: 50px;
    }
  }

  @media (max-width: 767px) {
    .single-pricing .pricing-header .price {
      font-size: 50px;
    }
  }

  @media only screen and (min-width: 576px) and (max-width: 767px) {
    .single-pricing .pricing-header .price {
      font-size: 64px;
    }
  }

  .single-pricing .pricing-header .year {
    font-size: 20px;
    font-weight: 500;
    line-height: 1.25;
    margin-top: 3px;
    background: #FC0;
    color: #000;
    padding: 5px 10px;
    text-transform: uppercase;
  }

  .single-pricing .pricing-list ul {
    list-style: none;
    padding: 0;
  }

  .single-pricing .pricing-list ul li {
    text-align: center;
    font-size: 16px;
    line-height: 24px;
    color: #121212;
    padding: 16px 0;
    border-bottom: 1px solid #EEE;
  }

  .single-pricing .pricing-list ul li > img {
    width: 100%;
    height: 160px;
    object-fit: contain;
    margin-bottom: 8px;
  }

  .single-pricing .pricing-list ul li:nth-last-child(1) {
    border-bottom: 1px solid transparent;
  }

  @media only screen and (min-width: 992px) and (max-width: 1200px) {
    .single-pricing .pricing-list ul li {
      font-size: 14px;
      margin-top: 12px
    }
  }

  @media (max-width: 767px) {
    .single-pricing .pricing-list ul li {
      font-size: 14px;
      margin-top: 12px
    }
  }

  @media only screen and (min-width: 576px) and (max-width: 767px) {
    .single-pricing .pricing-list ul li {
      font-size: 16px;
      margin-top: 16px
    }
  }

  .single-pricing .pricing-list ul li i {
    color: #FF6F00;
    margin-right: 8px
  }

  .single-pricing .pricing-btn {
    margin-top: 24px
  }

  .single-pricing .pricing-btn .main-btn {
    background-color: #FFF;
    border-radius: 50px;
    color: #000;
    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.16);
    padding: 16px 24px;
    font-weight: 500;
    text-decoration: none;
    letter-spacing: 0.5px;
    width: 100%;
  }

  .pavyon-btn{
    animation: changeBG 0.8s infinite;
  }

  .single-pricing .buttom-shape {
    position: absolute;
    bottom: -20px;
    left: 0;
    width: 101%
  }

  .single-pricing.pro .pricing-header .sub-title::before {
    right: auto;
    left: 0;
    background-color: #FF6F00
  }

  .single-pricing.pro .pricing-baloon {
    position: absolute;
    top: 0;
    right: -78px;
    width: 156px
  }

  .single-pricing.enterprise .pricing-header .sub-title::before {
    right: 0;
    left: auto;
    background-color: #FF6F00
  }

  .single-pricing.enterprise .pricing-flower {
    position: absolute;
    top: 10px;
    left: 10px;
    width: 144px
  }

  .text-black-50 {
    text-transform: uppercase;
  }

  @media only screen and (min-width: 992px) and (max-width: 1200px) {
    .single-pricing.enterprise .pricing-flower {
      width: 110px
    }
  }

  @media (max-width: 767px) {
    .single-pricing.enterprise .pricing-flower {
      width: 110px
    }
  }

  @media only screen and (min-width: 576px) and (max-width: 767px) {
    .single-pricing.enterprise .pricing-flower {
      width: 144px
    }
  }

  @-webkit-keyframes changeBG {
    0% {
      transform: scale(1);
      background-color: #F42;
      color: #FFF;
    }

    50.0% {
      transform: scale(1.05);
      background-color: #FC0;
      color: #000;
    }

    100% {
      transform: scale(1);
      background-color: #F42;
      color: #FFF;
    }
  }


  @keyframes changeBG {
    0% {
      transform: scale(1);
      background-color: #F42;
      color: #FFF;
    }

    50.0% {
      transform: scale(1.05);
      background-color: #FC0;
      color: #000;
    }

    100% {
      transform: scale(1);
      background-color: #F42;
      color: #FFF;
    }
  }

  .sms-iptal {
    background-color: #F0F0F0;
  }

  .sms-iptal.single-pricing .pricing-list ul li {
    border-bottom: 1px solid #CCC;
  }
</style>
